export const Muted = (props: any) => {
  return (
    <svg
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 48 48"
      {...props}
    >
      <g>
        <path
          fill="#333"
          d="M26.102 10.104c-.063-.702-.211-1.67-.86-2.45a4 4 0 0 0-3.267-1.437c-1.013.049-1.826.594-2.386 1.022-.586.448-1.278 1.082-2.069 1.807L12.39 13.75H10.56c-.778 0-1.479 0-2.061.047-.624.051-1.287.166-1.937.497a5 5 0 0 0-2.185 2.186c-.331.65-.446 1.312-.497 1.936-.048.583-.048 1.283-.048 2.061v7.046c0 .778 0 1.478.048 2.06.05.625.166 1.288.497 1.937a5 5 0 0 0 2.185 2.186c.65.33 1.313.446 1.937.497.582.047 1.283.047 2.06.047h1.829l5.131 4.704c.791.725 1.483 1.36 2.069 1.807.56.428 1.373.973 2.386 1.022a4 4 0 0 0 3.267-1.437c.649-.78.797-1.747.86-2.45.065-.735.065-1.673.065-2.745V12.85c0-1.073 0-2.011-.066-2.746Zm-5.946 1.952c.878-.805 1.436-1.314 1.862-1.639l.088-.066.011.11c.048.534.05 1.289.05 2.48V35.06c0 1.19-.002 1.945-.05 2.48l-.01.11a5.319 5.319 0 0 1-.09-.067c-.425-.325-.983-.834-1.86-1.639l-5.18-4.747-.033-.031c-.122-.113-.372-.346-.677-.52a3.004 3.004 0 0 0-.827-.322 3.773 3.773 0 0 0-.85-.074h-1.957c-.873 0-1.408-.001-1.808-.034a2.546 2.546 0 0 1-.367-.05.58.58 0 0 1-.063-.018l-.016-.007a1 1 0 0 1-.437-.437l-.006-.015a.605.605 0 0 1-.018-.064 2.561 2.561 0 0 1-.05-.367c-.033-.4-.035-.934-.035-1.808v-6.9c0-.873.002-1.408.034-1.808.015-.186.035-.299.05-.367a.605.605 0 0 1 .019-.064l.006-.015a1 1 0 0 1 .437-.437l.016-.007c.01-.004.03-.01.063-.018.068-.016.181-.035.367-.05.4-.033.935-.034 1.808-.034h1.956c.166 0 .508.003.851-.074.29-.066.569-.174.827-.322.305-.174.555-.407.677-.52l.033-.03 5.18-4.748Z"
          clipRule="evenodd"
          fillRule="evenodd"
          data-follow-fill="currentColor"
        ></path>
        <path
          fill="#333"
          d="M28.29 19.093a.991.991 0 0 1 0-1.402l1.401-1.4a.991.991 0 0 1 1.402 0L36 21.197l4.907-4.908a.991.991 0 0 1 1.402 0l1.4 1.401a.991.991 0 0 1 0 1.402L38.803 24l4.908 4.907a.991.991 0 0 1 0 1.402l-1.401 1.4a.991.991 0 0 1-1.402 0L36 26.803l-4.907 4.908a.991.991 0 0 1-1.402 0l-1.4-1.401a.991.991 0 0 1 0-1.402L33.197 24l-4.908-4.907Z"
          data-follow-fill="currentColor"
        ></path>
      </g>
    </svg>
  )
}
